import(/* webpackMode: "eager" */ "/vercel/path0/src/app/(swap)/nft/page.tsx");
